import { render, staticRenderFns } from "./Typeahead.vue?vue&type=template&id=a4643d7a&"
import script from "./Typeahead.vue?vue&type=script&lang=ts&"
export * from "./Typeahead.vue?vue&type=script&lang=ts&"
import style0 from "./Typeahead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports